import { Button } from '@library/components/buttons';
import type { ReactNode } from 'react';
import { forwardRef } from 'react';

export interface KebabMenuItemButtonProps {
  className: string;
  children: ReactNode;
  disabled: boolean;
  handleOnClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

export const KebabMenuItemButton = forwardRef<
  HTMLDivElement,
  KebabMenuItemButtonProps
>(
  (
    { className, disabled, handleOnClick, children }: KebabMenuItemButtonProps,
    ref
  ) => {
    return (
      <div className="flex" ref={ref}>
        <Button
          className={className}
          disabled={disabled}
          onClick={handleOnClick}
          type="button"
        >
          {children}
        </Button>
      </div>
    );
  }
);
